import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_For_more_information_about_dep_ELL_1,
  TXTWCL_Processing_time_may_vary_depen_ELL,
  TXTWCL_We_will_let_you_know_if_you_ne_ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_Processing_time_may_vary_depen_ELL} />{' '}
    <Translation {...TXTWCL_We_will_let_you_know_if_you_ne_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenterDepositWithdrawal}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_For_more_information_about_dep_ELL_1}
    />
  </>
);

export default HelpSectionContent;
